<template>
    <div class="AutoReply">
        <a-card style="margin-bottom:30px;">
            <div class="tit">
                <h6>自动回复</h6>
                <a-switch :loading="switchLoading" v-model="wechatCustomInfo.enabled" @change="switchChange"></a-switch>
            </div>
            <p>通过编辑内容或关键词规则，快速进行自动回复设置。如具备开发能力，可更灵活地使用该功能。</p>
            <p>关闭自动回复之后，将立即对所有用户生效。</p>
        </a-card>
        <a-card>
            <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="关键词回复">
                    <a-form-model layout="inline">
                        <a-form-model-item>
                            <a-input placeholder="搜索关键词/规则名称" allow-clear v-model="searchName"
                                     @keyup.enter="isSearch"/>
                        </a-form-model-item>
                        <a-form-model-item>
                            <a-button type="primary" @click="isSearch()">查询</a-button>
                        </a-form-model-item>
                        <a-form-model-item>
                            <a-button type="primary" @click="Add.visible = true" icon="plus">添加回复</a-button>
                        </a-form-model-item>
                    </a-form-model>
                    <div style="overflow: auto;margin-top:15px;">
                        <a-table
                            style="min-width: 800px;"
                            :columns="columns"
                            :pagination="tableRelevant.tablePagination"
                            :loading="tableRelevant.tableLoading"
                            :locale="tableRelevant.locale"
                            :dataSource="tableRelevant.tableDataSource">
                            <div slot="keyWordList" slot-scope="text, record">
								<span v-for="item in text.keyWordList">
									{{ item.content }}
								</span>
                            </div>
                            <div slot="replyList" slot-scope="text, record">
                                <span v-if="text.replyList.length">{{ text.replyType }}</span>
                            </div>
                            <div slot="action" class="action" slot-scope="text, record">
                                <a @click="isEdit(text)">
                                    <a-icon type="edit"/>
                                    编辑</a>
                                <a @click="isDetail(text)">
                                    <a-icon type="database"/>
                                    详情</a>
                                <a-popconfirm
                                    title="确定删除？"
                                    ok-text="确定"
                                    cancel-text="取消"
                                    @confirm="idDelete(text)">
                                    <a style="color: #f00;">
                                        <a-icon type="delete"/>
                                        删除
                                    </a>
                                </a-popconfirm>
                            </div>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="收到消息回复">
                    <div class="box" style="position: relative;z-index: 1;">
                        <pre style="white-space-collapse: inherit;" spellcheck="false">
                            <a-input style="width: 100%;height: 250px;;"
                                     v-model="textareaContent"
                                     type="textarea"/>
                        </pre>
                    </div>
                    <div class="btns">
                        <a-button @click="saveMessage" :loading="saveLoading" type="primary" style="margin-right:15px;">
                            保存
                        </a-button>
                        <a-button @click="idDelete(wechatCustomInfo.details[0])">删除回复</a-button>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="3" tab="被关注回复">
                    <div class="box" style="position: relative;z-index: 1;">
                        <pre style="white-space-collapse: inherit;" spellcheck="false">
                            <a-input style="width: 100%;height: 250px;;"
                                     v-model="textareaContent"
                                     type="textarea"/>
                        </pre>
                    </div>
                    <div class="btns">
                        <a-button @click="saveMessage" :loading="saveLoading" type="primary" style="margin-right:15px;">
                            保存
                        </a-button>
                        <a-button @click="idDelete(wechatCustomInfo.details[0])">删除回复</a-button>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-card>
        <!-- 详情 -->
        <a-modal v-model="Detail.visible" title="详情" :footer="null">
            <div style="display: flex;margin-bottom:30px;">
                <span style="font-size: 14px;color: #7e8081;width: 60px;">关键词</span>
                <div style="margin-left: 30px;width: 80%;">
                    <em v-for="item in Detail.record.keyWordList"
                        style="font-style: normal;margin-right: 15px;color: #1a1b1c;">
                        {{ item.content }}
                        <i style="font-style: normal;color: #7e8081;">({{ item.matchMode == 1 ? '半匹配' : '全匹配' }})</i>
                    </em>
                </div>
            </div>
            <div style="display: flex;">
                <span style="font-size: 14px;color: #7e8081;width: 60px;display:block;">回复内容</span>
                <div style="margin-left: 30px;width: 80%;">
                    <div v-for="(item,index) in Detail.record.replyList" class="reply-box">
                        <div v-if="item.type === 5">
                            {{ item.content }}
                        </div>
                        <div v-else-if="item.type === 0">
                            <img
                                :src="baseURL + '/base/WechatMedia/GetForeverMedia?fileType=0&mediaId=' + item.content"
                                style="width: 110px;height: 110px;object-fit: cover"
                                referrerpolicy="no-referrer" alt="">
                            <p>{{ item.name }}</p>
                        </div>
                        <div v-else-if="item.type === 1">
                            <audio controls
                                   :src="baseURL + '/base/WechatMedia/GetForeverMedia?fileType=1&mediaId=' + item.content"></audio>
                        </div>
                        <div v-else>
                            <a :href="item.url" target="_blank">
                                <a-icon type="video-camera" style="color: #13c2c2;"/>
                                {{ item.name }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
        <!-- 添加回复 -->
        <a-modal v-model="Add.visible" title="添加回复" @ok="AddSubmit" @cancel="cancelSubmit">
            <a-form-model
                ref="addForm"
                style="max-height: 400px;overflow-y: auto;"
                v-bind="formItemLayoutWithOutLabel"
                :model="Add.form"
                :rules="Add.rules">
                <a-form-model-item label="规则名称" prop="ruleName" v-bind="formItemLayout">
                    <a-input style="width: 90%; margin-right: 8px" :maxlength="60"
                             v-model="Add.form.ruleName" placeholder="请输入规则名称"/>
                </a-form-model-item>

                <a-form-model-item
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    v-bind="index === 0 ? formItemLayout : {}"
                    :key="domain.key"
                    :label="index === 0 ? '关键词' : ''"
                    prop="replyKey">
                    <div style="display:flex;margin-top: 3px;">
                        <a-select v-model="domain.matchMode" style="width: 30%;">
                            <a-select-option :value="1">半匹配</a-select-option>
                            <a-select-option :value="2">全匹配</a-select-option>
                        </a-select>
                        <a-input
                            v-model="domain.value"
                            placeholder="请输入关键词"
                            style="width: 60%; margin-right: 8px"
                        />
                        <a-icon
                            v-if="dynamicValidateForm.domains.length > 1"
                            class="dynamic-delete-button"
                            type="minus-circle-o"
                            :disabled="dynamicValidateForm.domains.length === 1"
                            @click="removeDomain(domain)"
                        />
                    </div>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="dashed" style="width: 90%" @click="addDomain">
                        <a-icon type="plus"/>
                        添加关键词
                    </a-button>
                </a-form-model-item>

                <a-form-model-item label="回复内容" prop="replyContent" v-bind="formItemLayout">
                    <div v-for="(item,index) in reply.list" class="reply-box">
                        <div v-if="item.type === 5">
                            {{ item.content }}
                            <a-icon @click="replyContent(1,item,index)" type="edit" style="margin-left: 10px;"/>
                            <a-icon @click="deleteReply(item,index)" type="delete"
                                    style="margin-left: 10px;color:#f00;"/>
                        </div>
                        <div v-else-if="item.type === 0">
                            <img
                                :src="baseURL + '/base/WechatMedia/GetForeverMedia?fileType=0&mediaId=' + item.content"
                                style="width: 110px;height: 110px;object-fit: cover"
                                referrerpolicy="no-referrer" alt="">
                            <a-icon @click="deleteReply(item,index)" type="delete"
                                    style="margin-left: 10px;color:#f00;"/>
                            <p>{{ item.name }}</p>
                        </div>
                        <div v-else-if="item.type === 1">
                            <audio controls
                                   :src="baseURL + '/base/WechatMedia/GetForeverMedia?fileType=1&mediaId=' + item.content"></audio>
                            <a-icon @click="deleteReply(item,index)" type="delete"
                                    style="margin-left: 10px;color:#f00;"/>
                        </div>
                        <div v-else>
                            <a :href="item.url" target="_blank">
                                <a-icon type="video-camera" style="color: #13c2c2;"/>
                                {{ item.name }}
                            </a>
                            <a-icon @click="deleteReply(item,index)" type="delete"
                                    style="margin-left: 10px;color:#f00;"/>
                        </div>
                    </div>
                    <a-button-group>
                        <a-button @click="replyContent(1)" icon="font-size">文字</a-button>
                        <a-button @click="replyContent(2)" icon="file-image">图片</a-button>
                        <a-button @click="replyContent(3)" icon="audio">音频</a-button>
                        <a-button @click="replyContent(4)" icon="video-camera">视频</a-button>
                    </a-button-group>

                </a-form-model-item>
                <a-form-model-item label="回复方式" prop="replyMode" v-bind="formItemLayout">
                    <a-radio-group v-model="Add.form.replyMode">
                        <a-radio :value="1">随机回复一条</a-radio>
                        <a-radio :value="2">回复全部</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
        </a-modal>

        <a-modal :title="reply.title"
                 v-model="reply.visible"
                 @ok="replyOk"
                 @cancel="reply.active = null"
                 width="600px" :centered="true">
            <div v-if="reply.type === 1" class="reply-content">
                <a-input style="width: 100%;height: 120px;" v-model="reply.text" type="textarea"/>
            </div>
            <div v-else-if="reply.type === 2" class="reply-content">
                <ul>
                    <li v-for="(item, index) in reply.mediaList"
                        :class="{active: index === reply.active}"
                        @click="reply.active === index ? reply.active = null : reply.active = index">
                        <img :src="item.url | filterUrl" alt="">
                        <p>{{ item.name }}</p>
                    </li>
                </ul>
            </div>
            <div v-else class="reply-content">
                <ul>
                    <li v-for="(item, index) in reply.mediaList"
                        :class="{active: index === reply.active}"
                        @click="reply.active === index ? reply.active = null : reply.active = index">
                        <div>{{ item.name }}</div>
                    </li>
                </ul>
            </div>
        </a-modal>
    </div>
</template>

<script>
import E from "wangeditor"
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const columns = [
    {title: '规则名称', dataIndex: 'ruleName'},
    {title: '关键词', scopedSlots: {customRender: 'keyWordList'}},
    {title: '回复内容', scopedSlots: {customRender: 'replyList'}},
    {title: '操作', scopedSlots: {customRender: 'action'}, align: 'center'}
];
export default {
    name: 'AutoReply',
    data() {
        return {
            baseURL: process.env.VUE_APP_API_BASE_URL,
            twoEditor: null,//富文本编辑器
            threeEditor: null,
            searchName: '',
            textareaContent: '',
            wechatCustomInfo: {enabled: false, type: 1},
            switchLoading: false,
            saveLoading: false,
            columns,
            tableRelevant: tableRelevant.call(this),
            oldData: [],
            Detail: {
                visible: false,
                record: {}
            },
            Add: {
                visible: false,
                form: {
                    id: '',
                    ruleName: '',
                    replyContent: '',
                    replyMode: 1,
                    replyKey: '',
                    type: 5
                },
                rules: {
                    ruleName: [
                        {required: true, message: '请输入规则名称', trigger: 'blur'}
                    ],
                    replyContent: [
                        {required: true, message: '请输入回复内容', trigger: 'blur'}
                    ],
                    replyMode: [
                        {required: true, message: '请选择回复方式', trigger: 'change'}
                    ],
                    replyKey: [
                        {required: true, message: '请输入关键词', trigger: 'blur'}
                    ]
                }
            },
            formItemLayout: {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 4},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 20},
                },
            },
            formItemLayoutWithOutLabel: {
                wrapperCol: {
                    xs: {span: 24, offset: 0},
                    sm: {span: 20, offset: 4},
                },
            },
            dynamicValidateForm: {
                domains: [
                    {
                        value: '',
                        matchMode: 1,
                        key: Date.now(),
                    }
                ],
            },
            reply: {
                type: 1,
                visible: false,
                title: "添加回复文字",
                active: null,
                mediaList: [],
                text: "",

                list: [],
                edit: false,
                index: 0
            }
        }
    },
    mounted() {
        this.getGetWechatCustommessage(1)
    },
    methods: {
        // 添加回复消息
        replyContent(type, item, index) {
            this.reply.type = type;
            this.reply.visible = true;
            const Params = {
                fileType: 0,
                offset: 0,
                count: 999
            }
            switch (type) {
                case 1:
                    this.reply.title = "添加回复文字";

                    this.Add.form.type = 5;
                    if (item) {
                        this.reply.text = item.content
                        this.reply.index = index
                        this.reply.edit = true
                    } else {
                        this.reply.text = ''
                        this.reply.index = 0
                        this.reply.edit = false
                    }
                    return;
                case 2:
                    this.reply.title = "选择回复图片";
                    Params.fileType = 0;
                    this.Add.form.type = 0;
                    break;
                case 3:
                    this.reply.title = "选择回复音频";
                    Params.fileType = 1;
                    this.Add.form.type = 1;
                    break;
                case 4:
                    this.reply.title = "选择回复视频";
                    Params.fileType = 2;
                    this.Add.form.type = 2;
                    break;
            }
            this.$http.Base.getOthersMediaList(Params).then(res => {
                const {data} = res;
                this.reply.mediaList = data.item;
            })
        },
        replyOk() {
            this.$message.destroy();
            if (this.reply.type === 1) {
                if (!this.reply.text) {
                    this.$message.error("请添加回复文字");
                    return
                }
                if (!this.reply.edit) {
                    this.reply.list.push({
                        type: this.Add.form.type,
                        content: this.reply.text
                    })
                } else {
                    this.reply.list.forEach((v, i) => {
                        if (i == this.reply.index) {
                            v.content = this.reply.text
                        }
                    })
                }
            } else {
                if (this.reply.active === null) {
                    this.$message.error("请" + this.reply.title);
                    return
                }
                this.reply.list.push({
                    ...this.reply.mediaList[this.reply.active],
                    type: this.Add.form.type,
                    content: this.reply.mediaList[this.reply.active].media_id
                })
            }
            this.Add.form.replyContent = this.reply.list;
            this.reply.visible = false;
        },
        deleteReply(item, index) {
            this.reply.list.splice(index, 1)
            console.log(this.tableRelevant.tableDataSource);
            this.Add.form.replyContent = this.reply.list;
        },
        // 消息自动回复开启关闭
        switchChange(value) {
            const Params = {
                "id": this.wechatCustomInfo.id,
                "enabled": value
            }
            this.switchLoading = true;
            this.$http.Base.updateEnabled(Params).then(res => {
                this.switchLoading = false;
                const {message} = res;
                this.$message.success(message);
            })
        },
        // 保存消息回复
        saveMessage() {
            function replaceHtmlTags(text) {
                text = text.replace(/\/n/g, "");
                text = text.replace(/"/g, "'");
                return text;
            }

            const Params = {
                "customMessageTypdId": this.wechatCustomInfo.id,
                "ruleName": this.wechatCustomInfo.type === 2 ? '收到消息回复' : '被关注回复',
                "replyMode": 0,
                "keyWordList": [],
                "replyList": [
                    {
                        "type": 5,
                        "content": replaceHtmlTags(this.textareaContent)
                    }
                ]
            }
            if (this.wechatCustomInfo.details[0]) {
                Params.id = this.wechatCustomInfo.details[0].id;
            }
            this.saveLoading = true;
            this.$http.Base.editCustommessage(Params).then(res => {
                const {message} = res;
                this.$message.success(message);
                this.getGetWechatCustommessage(this.wechatCustomInfo.type);
            }).finally(() => {
              this.saveLoading = false;
            })
        },
        callback(e) {
            this.getGetWechatCustommessage(e)

        },
        getGetWechatCustommessage(type) {
            this.$http.Base.GetGetWechatCustommessageByType({type: type})
                .then(res => {
                    const {data} = res;
                    this.textareaContent = "";
                    this.wechatCustomInfo = data;
                    if (type == 1) {
                        this.tableRelevant.tableDataSource = data.details.map(m => {
                            const list = ["图片", "语音", "视频", "文章", " 图文消息", "文本"];
                            const obj = m.replyList.reduce((prev, curr) => {
                                prev[list[curr.type]] ? prev[list[curr.type]]++ : prev[list[curr.type]] = 1
                                return prev;
                            }, {});
                            m.replyType = Object.keys(obj).map(m1 => m1 + "：" + obj[m1]).join("，");
                            return m
                        })
                        this.oldData = data.details
                    } else {
                        try {
                            this.textareaContent = data.details[0].replyList[0].content
                        } catch (e) {

                        }
                    }
                })
        },
        isSearch() {
            if (this.searchName) {
                let arr = []
                this.oldData.forEach(v => {
                    v.keyWordList.forEach(n => {
                        if (v.ruleName.includes(this.searchName) || (n.content.includes(this.searchName) && n.matchMode == 1) || (n.content == this.searchName && n.matchMode == 2)) {
                            arr.push(v)
                        }
                    })
                })
                console.log(arr);
                this.tableRelevant.tableDataSource = [...new Set(arr)]
            } else {
                this.getGetWechatCustommessage(1)
            }
        },
        isDetail(text) {
            this.Detail.visible = true
            this.Detail.record = text
            this.getMaterial(this.Detail.record.replyList, true)
        },

        addDomain() {
            this.dynamicValidateForm.domains.push({
                value: '',
                matchMode: 1,
                key: Date.now(),
            });
        },
        removeDomain(item) {
            let index = this.dynamicValidateForm.domains.indexOf(item);
            if (index !== -1) {
                this.dynamicValidateForm.domains.splice(index, 1);
            }
        },
        cancelSubmit() {
            this.$refs.addForm.resetFields();
            this.reply.list = []
            this.dynamicValidateForm = {
                domains: [
                    {
                        value: '',
                        matchMode: 1,
                        key: Date.now(),
                    }
                ],
            }
            this.resetForm()
        },
        AddSubmit(text) {
            let params = {
                customMessageTypdId: 1,
                ruleName: this.Add.form.ruleName,
                replyMode: this.Add.form.replyMode,
                keyWordList: [],
                replyList: this.Add.form.replyContent
            }
            this.dynamicValidateForm.domains.forEach(v => {
                let str = {
                    matchMode: '',
                    content: ''
                }
                str.matchMode = v.matchMode
                str.content = v.value
                params.keyWordList.push(str)
            })
            if (this.Add.form.id) {
                params.id = this.Add.form.id
            }
			this.Add.form.replyKey = this.dynamicValidateForm.domains.every(v => v.value) ? 1 : ''
            this.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$http.Base.editCustommessage(params)
                        .then(res => {
                            const {message} = res;
                            this.Add.visible = false
                            this.getGetWechatCustommessage(1)
                            this.$message.success(message)
                            this.$refs.addForm.resetFields();
                            this.reply.text = ''
                            this.dynamicValidateForm = {
                                domains: [
                                    {
                                        value: '',
                                        matchMode: 1,
                                        key: Date.now(),
                                    }
                                ],
                            }
                            this.resetForm()
                            this.reply.list = []
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        idDelete(text) {
            if (typeof text !== "object") {
                return
            }
            const formData = new FormData();
            formData.append('id', text.id)
            this.$http.Base.deleteCustommessage(formData)
                .then(res => {
                    const {message} = res;
                    this.getGetWechatCustommessage(this.wechatCustomInfo.type)
                    this.$message.success(message)
                })
        },
        isEdit(text) {
            this.Add.visible = true
            this.dynamicValidateForm.domains = []
            text.keyWordList.forEach(v => {
                let str = {
                    value: v.content,
                    matchMode: v.matchMode,
                    key: Date.now(),
                }
                this.dynamicValidateForm.domains.push(str)
            })
            this.reply.list = text.replyList
            this.getMaterial(text.replyList);
            this.Add.form = {
                replyKey: '',
                ruleName: text.ruleName,
                replyContent: text.replyList,
                replyMode: text.replyMode,
                type: this.wechatCustomInfo.type,
                id: text.id
            }
        },
        resetForm() {
            this.Add.form = {
                id: '',
                ruleName: '',
                replyContent: '',
                replyMode: 1,
                replyKey: '',
                type: 5
            }
        },

        async getMaterial(list, type) {
            const arr = [];
            for (let i = 0; i < list.length; i++) {
                if (list[i].type === 2) {
                    const data = (await this.$http.Base.getForeverVideo({mediaId: list[i].content})).data;
                    arr.push({
                        name: data.data.title,
                        url: data.data.down_url,
                        ...list[i]
                    })
                } else {
                    arr.push(list[i])
                }
            }
            if (type) {
                this.Detail.record.replyList = arr;
                return
            }
            this.reply.list = arr;
        }
    }
}
</script>

<style scoped lang="less">
.tit {
    display: flex;
    width: 70%;
    justify-content: space-between;
}

h6 {
    font-size: 16px;
}

p {
    font-size: 14px;
    margin-bottom: 0px;
    color: #B1b2b3;
}

.btns {
    margin-top: 30px;
}

.box pre {
    white-space: break-spaces;
}

.reply-box {
    margin-bottom: 10px;
}

.reply-content {
    width: 100%;
    min-height: 150px;
    max-height: 400px;
    overflow-y: auto;

    ul {
        padding: 0;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
    }

    li {
        width: 110px;
        min-height: 110px;
        margin-right: 20px;
        margin-bottom: 20px;
    }

    li.active img, li.active div {
        border-color: @primary-color;
    }

    img {
        width: 110px;
        height: 110px;
        border: 2px solid transparent;
    }

    div {
        width: 110px;
        min-height: 110px;
        border: 2px solid transparent;
    }
}
</style>
